export default class Menu {

    constructor()
    {
        Menu.initializeBurgerMenu();
        Menu.subMenuEvent();
    }

    static initializeBurgerMenu() {
        let burger_menu = '[data-burger-menu]';

        $( document ).on( 'click', burger_menu, function ( e ) {
            $('body').toggleClass('noscroll wpiris-menuOpen');
            $(this).toggleClass('open');
            $('.wpirisMenu').toggleClass('open');
            $('.sub-menu-open').removeClass('sub-menu-open');
        } );
    }

    static subMenuEvent() {
        const $menuEntryLinks = $('.mainnav .main-entry.has-submenu .main-entry__link');
        const $subMenuReturn = $('[data-trigger="sub-menu-return"]');

        if(window.matchMedia( "(max-width: 1200px)" ).matches) {
            $menuEntryLinks.on( 'click', function( e ) {
                e.preventDefault();
                $menuEntryLinks.find('+ .sub-menu').removeClass('sub-menu-open');
                $(this).find('+ .sub-menu').addClass('sub-menu-open');
                $(this).parents('.wpirisMenu').addClass('has-sub-menu-open');
            });

            $subMenuReturn.on( 'click', function( e ) {
                $(this).parents('.sub-menu-open').removeClass('sub-menu-open');
                $(this).parents('.wpirisMenu').removeClass('has-sub-menu-open');
            });
        }
    }

    static menu() {
        let element = "#wpiris-menu";
        let a      = "[data-id='wpiris-menu'] ul:not(.sub-menu) > li > a";
        let li      = "[data-id='wpiris-menu'] ul:not(.sub-menu) > li";
        let a_open = "[data-id='wpiris-menu'] ul:not(.sub-menu) > li.isOpen > a";

        if ( window.matchMedia( "(min-width: 1000px)" ).matches ) {
            $( document ).on( 'click', a, function ( e ) {
                $( a ).parent().removeClass( 'isOpen' );
                $( a ).parent().addClass( 'disabled' );
                $( this ).parent().removeClass( 'disabled' );

                if ( $( this ).parent().hasClass( 'menu-item-has-children' ) ) {
                    e.preventDefault();
                    $( this ).parent().addClass( 'isOpen' );
                    $( element ).addClass( 'submenuOpen' );
                }
            });

            // Second click
            $( document ).on( 'click', a_open, function ( e ) {
                window.location = e.target.href;
            });

        } else {
            // Menu mobile

            $("[data-id='wpiris-menu'] ul:not(.sub-menu) > li > .sub-menu").prepend('<li data-trigger="wpiris-menu-back"><a href="#">retour</a></li>');

            $(document).on("click", '[data-trigger="wpiris-menu-more"]', function () {

                $(this).parents('li').addClass('submenuOpen');

            });

            // Lors du clic sur le li "dl-back" on supprime la class 'ouvert' sur le li.
            $(document).on("click", '[data-trigger="wpiris-menu-back"]', function () {
                let ul_parent = $(this).parent();
                let li_parent = $(this).parent().parent();

                $(ul_parent).stop().animate({
                    opacity: 0.25,
                    left: "100%"
                }, function () {
                    $(this).css({
                        display: 'none'
                    });
                });
            });

        }
    }
}